export default (store) => {
    return (to) => {
        if (to.meta.requiresRole &&
            (!store.state.auth.user ||
                !to.meta.requiresRole.includes(store.state.auth.user.role))) {
            console.debug('Incorrect role, redirect to 403')
            return '403'
        }

        return true
    }
}
